module.exports = __webpack_public_path__ + "img/Chicken.70b85222.png";